/** Karta podsumowania po zakończeniu przeglądu (event WS `review.finished`). */

import { Link } from "react-router-dom";
import { ReviewStatsList } from "../review/ReviewPage";
import type { ReviewSessionState } from "../review/types";

export function ReviewSummaryCard({ session }: { session: ReviewSessionState }) {
  const skipped = session.stats.steps_skipped.map(
    (key) => session.steps.find((step) => step.key === key)?.title ?? key,
  );

  return (
    <div className="card review-summary">
      <div className="card__head">
        <h3 className="card__title">Przegląd zamknięty</h3>
        <span className="badge">{session.space_scope ?? "wszystko"}</span>
      </div>

      <ReviewStatsList stats={session.stats} />

      {skipped.length > 0 && (
        <p className="muted">Pominięte kroki: {skipped.join(", ")}.</p>
      )}

      <Link className="btn btn--small" to="/przeglad">
        Ekran przeglądu
      </Link>
    </div>
  );
}
